import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minutesLabel',
  standalone: true,
})
export class MinutesLabelPipe implements PipeTransform {
  /**
   * 60分以上の「xx分」表示の値を「aa.bb時間」表示に変更する。（少数第２位まで丸める）
   * 60分未満の場合はそのまま「xx分」で返す。
   */
  transform(inputMinutes: number): string {
    // 60分未満の場合、そのままの値を用いる。
    if (inputMinutes < 60) {
      return `${inputMinutes}分`;
    }

    // 小数第2位までに丸めてから parseFloat で末尾のゼロを削る
    const hours = parseFloat((inputMinutes / 60).toFixed(2));
    return `${hours}時間`;
  }
}
